import { CandidateType } from '../features/candidates/Candidates.types';
import { usePostFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export type FetchCandidatesResponseType = {
  count: number;
  results: CandidateType[];
};

export const useGetAllCandidates = () =>
  usePostFetch<FetchCandidatesResponseType>(pathToUrl(ApiRoutesEnum.searchCandidates), { criteria: [], max: 10000 });
